<template>
<div class="modal-wrapper colored-modal-wrapper">
    <div class="modal modal-lg" data-aos="fade-down">
        <div class="close-modal-btn" @click="closeModal()">
            <img src="../../assets/icons/close_icon.svg" />
        </div>

        <div class="signature-about">
            <div class="modal-title modal-title-sm">
                <p>Datenschutzvollmacht</p>
            </div>
            <div class="signature-about-content">
                <p>
                    Autorisierungsformular<br>
                    {{formattedDate}}

                    <br>
                    <span v-if="userInfo && userInfo.firstName && userInfo.lastName">
                        Vorname Nachname: {{userInfo.firstName}} {{userInfo.lastName}}
                    </span>
                    <br>
                    <span v-if="userInfo && userInfo.birthday">
                        Geburtstag: {{userInfo.birthday}}
                    </span>
                    <br>
                    <span v-if="userInfo && userInfo.address">
                        Adresse: {{userInfo.address}}
                    </span>
                    <span v-else>
                        [Adresse]
                    </span>
                    <br>

                    E-Mail-Adresse:
                    <span v-if="userInfo && userInfo.email">
                        {{userInfo.email}}
                    </span>
                    <span v-else>
                        [E-Mail]
                    </span>
                </p>

                <div>
                    <p>
                        Ich bevollmächtige CleanData (Rechtsträger: LEVELS AG, St. Galler Str. 5, CH-9042 Speicher, E-Mail: compliance@cleandata.ch) mich gegenüber datenverarbeitenden Stellen im In- und Ausland zu vertreten und in meinem Namen meine Datenschutzrechte geltend zu machen. 
                        <br>    
                        Dies umfasst insbesondere die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch und Datenportabilität gemäss:
                    </p>

                    <ul>
                        <li>
                            <p>
                                <b>Art. 15–21 der EU-Datenschutz-Grundverordnung (DSGVO),</b>
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Art. 8–16 des revidierten Schweizer Datenschutzgesetzes (revDSG),</b>
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>dem California Consumer Privacy Act (CCPA/CPRA)</b> sowie
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>vergleichbaren Datenschutzgesetzen anderer Länder,</b> soweit anwendbar.
                            </p>
                        </li>
                    </ul>

                    <p>
                        CleanData ist berechtigt, Auskunfts- und Löschbegehren zu stellen und die dazu nötigen Schritte in meinem Namen vorzunehmen. 
                        <br>
                        Diese Vollmacht gilt ab Unterzeichnung und kann jederzeit per E-Mail widerrufen werden. Bereits eingeleitete Schritte bleiben wirksam.
                    </p>
                </div>

            </div>

            <button v-if="loadingBtn" class="modal-btn modal-btn-sm">
                <p>Weiter</p>
            </button>
            <button v-else @click="setNextModal();" class="modal-btn modal-btn-sm">
                <p>Weiter</p>
            </button>
        </div>
    </div>
</div>
</template>

<script>
  import axiosInstance from "../../axios";

  export default {
      data() {
          return {

              signatureData: null,

              showMoreInfo: false,

              fullHeight: 0,

              loadingBtn: false,

              userInfo: {
                  email: '',
                  address: '',
              },

              mobile: false,
          }
      },
      async mounted() {
          await this.getProfilelData();
          this.userInfo = this.userPersonalData;
      },

      computed: {
          formattedDate() {
              return this.formatDate(new Date());
          },
      },
      methods: {
          formatDate(date) {
              return `Datum: ${new Intl.DateTimeFormat('de-CH', { 
                day: '2-digit', month: 'long', year: 'numeric', 
                hour: '2-digit', minute: '2-digit', hour12: false 
            }).format(date).replace(',', ' um')}`;
          },

          closeModal() {
              this.$store.commit("application/setMobileInformationModal", false);
          },

          async setNextModal() {
              this.loadingBtn = true;

              const result = await axiosInstance({
                  requiresAuth: true
              }).get("/customer/personalData");

              const user = result.data.data;

              this.$store.commit("application/setMobileInformationModal", false);

              if (user.showSignatureUploadWindow) {
                  this.$store.commit("application/setAddSignatureModal", true);
              } else if (user.showDocumentsUploadWindow) {
                  this.$store.commit("application/setAddDocumentsModal", true);
              }

              this.loadingBtn = false;
          }
      }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/modals.scss";

ul {
    list-style: none;
    padding-left: 16px;
    position: relative;

    li {
        position: relative;
        margin-bottom: 16px;

        &::before {
            content: '';
            position: absolute;
            left: -15px;
            top: 5px;
            width: 8px;
            height: 8px;
            background-color: #666666;
            border-radius: 50%;
        }

        p{
            margin: 0 !important;
        }
    }
}

.modal-btn {
    margin: 0 !important;
    margin-left: auto !important;
    margin-top: 30px !important;
}

.close-modal-btn {
    cursor: pointer;
}

.modal {
    width: 95%;
    flex-direction: column;
    margin: 50px auto;
    padding: 35px 20px;
    position: relative;
}

.modal-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
}

.signature-about {
    width: 100%;
    height: 100%;
}

.modal-title {
    text-align: left;
    margin-bottom: 11px;
}

.signature-about-content {

    p {
        color: #666666;
        font-size: 12px;
        transition: max-height 0.5s ease;
        overflow: hidden;

        &:first-child {
            margin-bottom: 20px;
        }
    }
}

/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {}

/* 2304-1470 */
@media (min-width: 2304px) {}

/* 2470 - 1328 */
@media (min-width: 2470px) {}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {}

/*2573-1206*/
@media(min-width: 2573px) {}

/* 2880-1670 */
@media(min-width: 2880px) {}

/* 3000-1870 */
@media(min-width: 3000px) {}

/*3200-1800*/
@media(min-width: 3200px) {}

/*3360-1890 1695*/
@media(min-width:3360px) {}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px) {}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {}

/*1688-1080*/
@media(max-width: 1688px) {}

/*1680-1080*/
@media(max-width: 1680px) {}

/*1640-1080*/
@media(max-width: 1640px) {}

/* 1600 - 757 */
@media (max-width: 1600px) {}

/*1536-864*/
@media(max-width:1536px) {}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {}

/*1366-638*/
@media (max-width:1366px) {}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {}

/* 1200-1920 */
@media (max-width:1200px) {}

/*1134x712*/
@media(max-width:1134px) {}

/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {}

/* 962x601 */
@media(max-width: 962px) {}

/* 900x1600 */
@media(max-width: 900px) {}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {}

/*712-1138*/
@media(max-width:712px) {}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {

    .modal-btn-sm {
        width: 168px;
        padding: 12px 0;

        p {
            font-size: 14px;
        }
    }
}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {}

/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {
    .signature-about-content p {
        font-size: 10px;
    }

    .modal {
        padding: 25px 15px;
        margin: 0px auto;
    }

    .modal-btn-sm {
        width: 140px;
    }
}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) {}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {
    .modal-btn-sm {
        width: 120px;
    }
}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {
    .modal-btn-sm {
        width: 110px;
    }
}

/* ip SE */
/*320x568*/
@media(max-width:320px) {}
</style>
